<script>
import DataTableRequestColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableRequestColumn.vue';
import ProdutoRequest from 'Modules/contacard/produto/product/ProdutoRequest';

export default {
  name: 'AntiFraduProductNameColumn',
  extends: DataTableRequestColumnVue,
  data: () => ({
    requestClass: ProdutoRequest,
    swalConfig: {
      showSuccessSwal: false,
      errorMessage: 'Falha ao buscar nome do produto!',
    },
    defaultPropertyName: 'nomProdutoServico',
  }),
};
</script>
